/**
 * Nano
 *
 * Базовый кэшер на основе класса Map (ES6)
 *
 * @class Nano
 * @extends {Map}
 */
class Nano extends Map {
  constructor(options = {}) {
    super()

    this._options = {
      ttl: options.ttl || 30 * 1000,
      ttlInterval: options.ttlInterval,
      renewOnGet: !!options.renewOnGet || false
    }
    if (!this._options.ttlInterval) {
      this._options.ttlInterval = this._options.ttl
    }

    this._interval = setInterval(() => {
      const now = Date.now()

      super.forEach((element, key) => {
        if (!element.expireAt || element.expireAt < now) {
          this._expireKey(key, element)
        }
      })
    }, this._options.ttlInterval)
  }

  get _mapGet() {
    return super.get
  }
  get _mapSet() {
    return super.set
  }
  get _mapHas() {
    return super.has
  }

  _expireKey(key) {
    super.delete(key)
  }

  _toCacheValue(value, options = {}) {
    const ttl = options.ttl || this._options.ttl

    return {
      value,
      expireAt: Date.now() + ttl,
      ttl
    }
  }
  _fromCacheValue(value) {
    return value.value
  }

  add(key, value, options = {}) {
    if (!this._mapHas(key)) {
      return this.set(key, value, options)
    }

    return options.returnSaved ? this.get(key) : undefined
  }

  set(key, value, options = {}) {
    if (value === undefined) {
      // eslint-disable-next-line no-console
      console.warn(`NanoCache (MicroCache dependance) does not work properly with undefined values! Key '${key}'.`)
    }

    const result = this._mapSet(key, this._toCacheValue(value, options))
    return options.returnSaved ? value : result
  }

  get(key) {
    const result = this._mapGet(key)

    if (result === undefined) {
      return undefined
    }

    if (this._options.renewOnGet) {
      const ttl = result.ttl || this._options.ttl
      result.expireAt = Date.now() + ttl
      result.ttl = ttl
    }

    return this._fromCacheValue(result)
  }

  forEach(callback, thisArg) {
    return super.forEach(({ value }, key, map) => {
      callback.call(
        thisArg, value, key, map
      )
    })
  }
}

module.exports = Nano
